const COOKIE_NAME = "barlo_consent";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 12 months

export const OPEN_SETTINGS_EVENT = "barlo:open-cookie-settings";
export const CONSENT_CHANGED_EVENT = "barlo:consent-changed";

export function getConsent() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"),
  );
  if (!match) return null;
  try {
    const value = JSON.parse(decodeURIComponent(match[1]));
    return { analytics: value.analytics === true };
  } catch {
    return null;
  }
}

export function saveConsent(analytics) {
  const value = encodeURIComponent(
    JSON.stringify({ analytics: analytics === true }),
  );
  document.cookie = `${COOKIE_NAME}=${value}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}
